import React, { createContext, useContext, useEffect, useState } from 'react';

import { getDeadPoolConfig } from '@/services/common';

const DeadPoolContext = createContext({
  deadPoolConfig: {} as { [key: string]: any },
  loading: false,
});

export const DeadPoolProvider = ({ children }: { children: any }) => {
  const [deadPoolConfig, setDeadPoolConfig] = useState<{ [key: string]: any }>(
    {},
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getDeadPoolConfig('bybit.us', ['cht.thirdBindGray.config'])
      .then((data: any) => {
        setDeadPoolConfig(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <DeadPoolContext.Provider
      value={{
        deadPoolConfig,
        loading,
      }}
    >
      {children}
    </DeadPoolContext.Provider>
  );
};

export const useDeadPoolStore = () => useContext(DeadPoolContext);
